var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { FormBaseElement, FormUtils } from '@unitarius/xbpm-runtime';
import { mapElementClass, omitSpecialProperties } from '../../common/utils/element.utils';
import { ControlError } from './ControlError';
import { AutoComplete } from 'primereact/autocomplete';
import * as R from 'ramda';
var execFormula = FormUtils.formula.execFormula;
var reqError = function () { return Promise.reject('Ошибка обрабоки запроса!'); };
var tryParseJson = function (res) {
    try {
        return JSON.parse(res);
    }
    catch (_a) {
        return res;
    }
};
var AutocompleteControl = /** @class */ (function (_super) {
    __extends(AutocompleteControl, _super);
    function AutocompleteControl(props) {
        var _this = _super.call(this, props) || this;
        _this.suggestRendered = true;
        _this.afterQuery = function (def) { return function (res) {
            var map = def.frontFormulas.formulaFrontOk;
            _this.suggestRendered = false;
            _this.setState({ suggestions: map ? execFormula(map, res) : res });
        }; };
        _this.onQuery = function (def) { return function (event) {
            var query = def.frontFormulas.formulaFrontQuery;
            if (query) {
                Promise.resolve().then(function () { return execFormula(query, __assign(__assign({}, _this.formulaDef), { value: event.query })); })
                    .then(function (res) { return res || reqError(); }, function () { return reqError(); })
                    .then(function (res) { return res.json ? res.json() : tryParseJson(res); })
                    .then(_this.afterQuery(def));
            }
        }; };
        _this.onToggle = function (target) {
            var type = target.actionButton;
            if (type) {
                _this.props.onEvent({ type: type, target: target });
            }
        };
        _this.state = __assign(__assign({}, _this.state), { suggestions: [] });
        return _this;
    }
    AutocompleteControl.prototype.shouldElementRender = function (state) {
        return !this.suggestRendered || _super.prototype.shouldElementRender.call(this, state);
    };
    AutocompleteControl.prototype.elementRender = function (def) {
        var _this = this;
        var _a = def.frontOptions, field = _a.field, hint = _a.hint, multiple = _a.multiple, label = _a.label, restOptions = __rest(_a, ["field", "hint", "multiple", "label"]);
        var supportedValues = def.supportedValues;
        var isCheckedSingleChip = !!multiple && !!this.value && !!this.value.filter(function (it) { return it.single; }).length;
        var suggest = this.state.suggestions;
        this.suggestRendered = true;
        var printLabel = label || def.label;
        return def.hidden ? (null) : React.createElement("div", { className: mapElementClass(restOptions) },
            React.createElement("label", { htmlFor: def.id, title: printLabel }, printLabel),
            React.createElement(AutoComplete, __assign({}, omitSpecialProperties(restOptions), { ref: function (ref) {
                    if (ref) {
                        ref['inputEl'].setAttribute('field-code', def.code);
                    }
                }, key: def.id, id: def.id, inputId: def.id, disabled: def.disabled, readonly: def.readonly, completeMethod: this.onQuery(def), field: field, suggestions: Array.isArray(suggest) ? suggest : [], onChange: function (evt) { return _this.handleChange(evt.value); }, onSelect: function () { return _this.onToggle(def); }, onUnselect: function () { return _this.onToggle(def); }, value: this.value, tooltip: hint, onBlur: function (e) {
                    _this.handleBlur(e);
                    _this.suggestRendered = false;
                    if (multiple && e.target) {
                        e.target['value'] = '';
                    }
                }, onFocus: this.handleFocus, multiple: multiple })),
            !!supportedValues && !!supportedValues.length && React.createElement("div", { className: 'autocomplete-chips' }, supportedValues.map(function (value) {
                var isSingle = supportedValues.filter(function (e) { return !!e.single; }).includes(value);
                return React.createElement("div", { key: value.value, className: !isSingle && isCheckedSingleChip ? 'inactive' : '', onClick: function () {
                        if (isSingle || !isCheckedSingleChip) {
                            var values = (!_this.value || !_this.value.filter(function (it) { return it.value === value.value; }).length) ? R.append(value, _this.value) : R.without([value], _this.value);
                            _this.handleChange(values);
                            _this.onToggle(def);
                        }
                    } }, value.value);
            })),
            React.createElement(ControlError, { error: this.error, touched: this.touched }));
    };
    return AutocompleteControl;
}(FormBaseElement));
export { AutocompleteControl };
//# sourceMappingURL=Autocomplete.js.map